<p *ngIf="error !== null">{{ error }}</p>
